import * as React from 'react';
/** @hidden */
export var usePropsContext = function usePropsContext(context, props) {
  var contextPropsCallback = React.useContext(context);
  var contextProps = contextPropsCallback(props);
  return contextProps;
};